/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Dialogue_Event_Group_LabelInputs */



/**
* | output |
* | --- |
* | "Combined Continuity & Dialogue Event Group" |
*
* @param {Ccsl_Export_Dialogue_Event_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_dialogue_event_group_label = /** @type {((inputs?: Ccsl_Export_Dialogue_Event_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Dialogue_Event_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'evenements continuite et dialogue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kombinierte Veranstaltungsgruppe für Kontinuität und Dialog")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di eventi di continuità e dialogo combinati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединенная группа по организации мероприятий по обеспечению преемственности и диалогу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de eventos combinados de continuidad y diálogo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("联合连续性与对话活动组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("継続性と対話イベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संयुक्त निरंतरता एवं संवाद कार्यक्रम समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Eventos Combinados de Continuidade e Diálogo")
	return /** @type {LocalizedString} */ ("Combined Continuity & Dialogue Event Group")
});